import React, { memo, useCallback, useEffect, useState } from 'react'
import styles from './AdminDashboard.module.scss'
import CommonLoadingSpinnerForPage from '../../../common/components/loading-spinner/CommonLoadingSpinnerForPage'
import { toast } from 'react-toastify'
import { Range } from 'react-date-range';
import AdminDashboardCards from './components/AdminDashboardCards'
import AdminLoansDashboardSection from './components/AdminLoansDashboardSection'
import AdminDashboardChart from './components/AdminDashboardChart'
import { BpsAdminDashboardData } from '../../../model/bps-admin/bps-admin-dashboard-data'
import { BpsAdminDashboardChartData } from '../../../model/bps-admin/bps-admin-dashboard-chart-data'
import bpsAdminService from '../../../httpService/BpsAdminService'
import { BpsAdminDashboardChartDataList } from '../../../model/bps-admin/bps-admin-dashboard-chart-data-list';

type Props = {}

const AdminDashboard: React.FC<Props> = memo((props: Props) => {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const [loadingChartData, setLoadingChartData] = useState(false)

    const [data, setData] = useState<BpsAdminDashboardData>()
    const [chartData, setChartData] = useState<BpsAdminDashboardChartDataList>()

    const [range, setRange] = useState<Range>({
        startDate: firstDay,
        endDate: lastDay,
        key: 'selection',
        showDateDisplay: false
    })

    const handleDateRangeChange = (range: Range) => {
        if (range.startDate && range.endDate) {
            if (range.startDate.getTime() === range.endDate.getTime()) return;
            setRange(range);
        }
    }

    const fetchData = useCallback(
        async () => {
            try {
                const response = await bpsAdminService.getDashboardData();

                const data = response.data;

                setData(data);
            } catch (error) {
                toast.error("There was an error fetching products")
            }
        },
        [],
    )

    const fetchChartData = useCallback(
        async () => {
            try {
                setLoadingChartData(true);

                const response = await bpsAdminService.getDashboardChartData(range.startDate!, range.endDate!);

                const data = response.data;

                setChartData(data);
            } catch (error) {
                toast.error("There was an error dashboard data")
            } finally {
                setLoadingChartData(false);
            }
        },
        [range],
    )

    useEffect(() => {
        fetchData();
    }, [fetchData])

    useEffect(() => {
        fetchChartData();
    }, [fetchChartData])

    return (
        <>
            <div className={`${styles.headerSection} ${styles.standardSectionPadding}`}>
                <div className={styles.text}>
                    General Overview
                    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.00004 16L0.583374 14.5833L7.16671 8L0.583374 1.41667L2.00004 0L10 8L2.00004 16Z" fill="#526069" />
                    </svg>
                </div>
            </div>
            <div className={`${styles.welcomeSection} ${styles.standardSectionPadding}`}>
                <b>Welcome,</b> Admin
            </div>
            <div className={styles.standardSectionPadding}>
                <AdminDashboardCards data={data} />
            </div>
            <div className={styles.standardSectionPadding}>
                <AdminLoansDashboardSection data={data}/>
            </div>
            <CommonLoadingSpinnerForPage loading={loadingChartData}>
                <AdminDashboardChart chartData={chartData} range={range} handleDateRangeChange={handleDateRangeChange} />
            </CommonLoadingSpinnerForPage>
        </>
    )
})

export default AdminDashboard